import { render, staticRenderFns } from "./wrapper.vue?vue&type=template&id=df74f4c8&scoped=true&lang=pug"
import script from "./wrapper.vue?vue&type=script&lang=coffee"
export * from "./wrapper.vue?vue&type=script&lang=coffee"
import style0 from "./wrapper.vue?vue&type=style&index=0&id=df74f4c8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df74f4c8",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ExpandingArc: require('/opt/build/repo/site/components/globals/expanding-arc.vue').default,BlocksList: require('/opt/build/repo/site/components/globals/blocks/list.vue').default})
